<template>
  <section>
    <b-row class="mx-1">
      <b-col xl="6" md="12" v-for="(item, index) in list" :key="item.id" class="my-3">
        <div class="categories-container">
          <FundMapMainCategory :mainCategory="item" :index="index" :isCategoryMap="true" />
        </div>
      </b-col>
    </b-row>
    <div class="d-flex align-item-start">
      <b-button class="col-1 btn ml-2 mt-2 link-button btn-primary" @click="() => this.$router.back()">
        Vissza
      </b-button>
    </div>
  </section>
</template>

<script>
import * as FundMapApi from '../../api/fundMap'
import FundMapMainCategory from '../../components/FundMapMainCategory.vue'
export default {
  data() {
    return {
      list: []
    }
  },
  components: {
    FundMapMainCategory
  },
  created: async function() {
    await this.fetchList()
  },
  methods: {
    fetchList: async function() {
      const mainCategories = await FundMapApi.getMainCategories()
      this.list = mainCategories
    }
  },
  mounted() {
    window.onbeforeunload = function(e) {
      e.returnValue = ''
      return ''
    }
  },
  beforeDestroy() {
    window.onbeforeunload = null
  }
}
</script>

<style lang="scss" scoped>
.categories-container {
  cursor: pointer;
  min-height: 50px;
  border: 1px solid #b2bec3;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0px 2px 8px rgba(99, 110, 114, 0.2);
}

.title {
  color: #636e72;
  margin-top: 9px;
  font-weight: 700;
  font-size: 32px;
}

@media all and (max-width: 577px) {
  .title {
    font-size: 24px;
  }
}

@media all and (max-width: 391px) {
  .title {
    font-size: 20px;
  }
  .category-icon {
    font-size: 20px;
  }
}
</style>
